import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';

const useRole = () => {
  const { userData } = useAuth();

  return useMemo(() => {
    const role = userData?.role || '';
    const isTeacher = role === 'teacher';
    const isAssistant = role === 'assistant';
    const isStudent = role === 'student';
    const isParent = role === 'parent';

    return {
      role,
      isTeacher,
      isAssistant,
      isStudent,
      isParent,
      canEdit: isTeacher,
      canDelete: isTeacher,
      canUpload: isTeacher,
      canCheckAttendance: isTeacher || isAssistant || isStudent,
      canSubmit: isStudent,
      canGrade: isTeacher,
    };
  }, [userData?.role]);
};

export default useRole;
